export type TPasswordRequirement = {
  label: string;
  isMet: boolean;
  classes?: unknown;
};

export type TLabeledRE = {
  label: string;
  re: RegExp;
};

export const defaultLabeledREs: TLabeledRE[] = [
  {
    label: "At least 12 characters",
    re: /(?=.{12,}$)/,
  },

  // {
  //   label: "at least one lowercase",
  //   re: /(?=.*[a-z])/,
  // },

  // {
  //   label: "at least one uppercase",
  //   re: /(?=.*[A-Z])/,
  // },

  {
    label: "At least one uppercase and lowercase letter",
    re: /^(?=.*[a-z])(?=.*[A-Z])/,
  },

  {
    label: "At least one number ",
    re: /(?=.*[0-9])/,
  },

  {
    label: "At least one special character (- @ $ ! % * ? &)",
    re: /(?=.*[-@$!%*?&])/,
  },
];
